import { EmailCampaignStep } from './EmailCampaignValidation';

const STEP_VALIDATION_ERROR_MESSAGE = 'Please resolve validation errors before continuing.';
const STEP_IDS_WITH_INLINE_VALIDATION_MESSAGE: ReadonlySet<EmailCampaignStep> = new Set([
  'TitleDescription',
  'AudienceSelection',
  'PreviewSchedule',
]);

type GuardedStepTransitionArgs = {
  stepId: EmailCampaignStep;
  validate: () => Promise<boolean>;
  onValid: () => void;
  setStepError: (value: string | null) => void;
};

export const runGuardedEmailStepTransition = async ({
  stepId,
  validate,
  onValid,
  setStepError,
}: GuardedStepTransitionArgs): Promise<boolean> => {
  setStepError(null);
  const isValid = await validate();
  if (!isValid) {
    if (STEP_IDS_WITH_INLINE_VALIDATION_MESSAGE.has(stepId)) {
      setStepError(STEP_VALIDATION_ERROR_MESSAGE);
    }
    return false;
  }

  onValid();
  return true;
};
